export function sequence(length: number): Array<number> {
  const seq = []
  for (let i = 0; i < length; i++) {
    seq.push(i)
  }
  return seq
}

export function empty(length: number): Array<number> {
  const seq = []
  for (let i = 0; i < length; i++) {
    seq.push(0)
  }
  return seq
}

export function split(amount: number, parts: number): Array<number> {
  return sequence(amount)
    .map(() => Math.floor(Math.random() * parts))
    .reduce((acc, index) => {
      acc[index] += 1
      return acc
    }, empty(parts))
}

export function conjoin(list: Array<string>, konj: string) {
  return list
    .reduceRight((acc, word) => {
      if (acc.length === 0) {
        return [word]
      } else if (acc.length === 1) {
        return [word, ` ${konj} `, ...acc]
      }
      return [word, ', ', ...acc]
    }, [])
    .join('')
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/array.js